import { Component, Input, OnInit } from '@angular/core';
import { UtilService } from '../../shared/services';

@Component({
  selector: 'app-thankyou-success-head',
  templateUrl: './thankyou-success-head.component.html',
  styleUrls: ['./thankyou-success-head.component.scss']
})
export class ThankyouSuccessHeadComponent implements OnInit {

  @Input() config;
  isMobile;

  constructor(
    public utilService: UtilService
  ) { }

  ngOnInit() {
    this.isMobile = this.utilService?.isMobile();
  }

}
